/* Petal Post: product options and pricing rules.
   Reads prices from the add-on products (rendered as JSON by snippets/petal-options.liquid),
   shows the options on the product page, and adds the main item plus all chosen add-ons
   to the cart in one go. */
(function () {
  var root = document.getElementById('petal-options');
  if (!root || root.dataset.ppReady) return;
  root.dataset.ppReady = '1';

  var data;
  try {
    data = JSON.parse(root.querySelector('script[data-pp-data]').textContent);
  } catch (e) {
    return;
  }
  var A = data.add;
  A.bqGreen = A.bqGreen || [];

  /* ---------- rules ---------- */
  var PER_25 = 25;                 // luxe wrapping and baby's breath are per 25 stems
  var BIG_ORDER_STEMS = 25;        // basket price steps up above this many stems...
  var BIG_ORDER_CENTS = 30000;     // ...or at this order value
  var LETTER_BIG_FROM = 100;       // letters cost more at 100+ stems
  var HAND_TIE_MAX = 75;           // reflexed roses: max stems that can be hand-tied

  var FEATURES = {
    'roses-en-masse': { luxe: 1, vessel: 1, orchid: 1, breathAuto: 1, letters: 1, ribbon: 1, unit: 'roses' },
    'reflexed-roses-en-masse': { luxe: 1, vessel: 1, orchid: 1, greenery: 1, shape: 1, handTie: 1, unit: 'reflexed roses' },
    'baby-roses-en-masse': { luxe: 1, vessel: 1, orchid: 1, breathBunch: 1, unit: 'baby roses' },
    'tulips-en-masse': { luxe: 1, vessel: 1, orchid: 1, breathBunch: 1, unit: 'tulips' },
    'peonies-en-masse': { luxe: 1, vessel: 1, orchid: 1, unit: 'peonies' }
  };
  var f = FEATURES[data.handle] || {};
  var isSub = data.type === 'Subscription';
  var tags = data.tags || [];
  function hasTag(t) { return tags.indexOf(t) !== -1; }
  if (!FEATURES[data.handle] && !isSub) {
    if (data.type === 'En masse') {
      // any new "by the stem" product: luxe wrapping, vase/basket, orchids, quote box
      var unit = String(data.title || '').replace(/\s*by the stem\s*$/i, '').toLowerCase() || 'stems';
      f = { luxe: 1, vessel: 1, orchid: 1, request: 1, unit: unit };
    } else {
      // any other product tagged pp-addons (for example bouquets)
      f = { vessel: 1, orchid: 1, request: 1, bqGreen: 1 };
      if (hasTag('pp-budget')) { f.budget = 1; f.bqGreen = 0; }
      if (hasTag('pp-no-greenery')) f.bqGreen = 0;
    }
  }
  // optional add-ons switched on by product tags, so new products need no code
  if (hasTag('pp-breath')) f.breathBunch = 1;

  /* ---------- helpers ---------- */
  function money(c) {
    var d = c / 100;
    return '$' + (Math.round(d) === d ? d.toFixed(0) : d.toFixed(2));
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch];
    });
  }
  function byId(list, id) {
    for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(id)) return list[i];
    return null;
  }
  function pick(list, o1, o2) {
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      if (o1 !== undefined && o1 !== null && String(v.o1) !== String(o1)) continue;
      if (o2 !== undefined && o2 !== null && String(v.o2) !== String(o2)) continue;
      return v;
    }
    return null;
  }
  function pickStartsWith(list, o1Start, o2Start) {
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      if (o1Start && String(v.o1 || '').indexOf(o1Start) !== 0) continue;
      if (o2Start && String(v.o2 || '').indexOf(o2Start) !== 0) continue;
      return v;
    }
    return null;
  }
  function uniq(list, key) {
    var out = [];
    list.forEach(function (v) { if (out.indexOf(v[key]) === -1 && v[key] != null) out.push(v[key]); });
    return out;
  }
  function form() {
    return document.querySelector('form[data-type="add-to-cart-form"]');
  }
  function mainVariant() {
    var fm = form();
    var input = fm && fm.querySelector('[name=id]');
    var v = input ? byId(data.main, input.value) : null;
    return v || data.main[0];
  }
  function stems() {
    var v = mainVariant();
    var n = v ? parseInt(v.o1, 10) : NaN;
    return isNaN(n) ? null : n;
  }
  function sizeName() {
    var mv = mainVariant();
    var size = mv ? String(mv.o1 || '') : '';
    if (size === 'Grand') size = 'Extra large';
    return size;
  }
  /* vase and hat box price steps by the value of the flowers: under $150, $150-249, $250-349, $350-549, $550+ */
  var VASE_STEPS = [15000, 25000, 35000, 55000];
  function vaseFor(material, cents) {
    var list = A.vase.filter(function (x) { return String(x.o1) === material; });
    var i = 0;
    while (i < VASE_STEPS.length && cents >= VASE_STEPS[i]) i++;
    return list[Math.min(i, list.length - 1)] || null;
  }
  function isVaseChoice(vs) { return vs === 'Glass' || vs === 'Ceramic' || vs === 'Hat box'; }
  function vaseLabel(vs) { return vs === 'Hat box' ? 'Hat box' : vs + ' vase'; }
  function letterCount(str) {
    return (str || '').replace(/[^A-Za-z0-9&]/g, '').length;
  }

  /* ---------- markup ---------- */
  var html = '<fieldset class="pp-box"><legend class="pp-title">Make it yours</legend>';

  if (isSub) {
    html += '<p class="pp-note">Your first delivery includes a starter vase (one-off charge). We\'ll be in touch to confirm your start date and colours.</p>';
    html += '<label class="pp-check"><input type="checkbox" id="pp-starter" checked> <span>Add starter vase, one-off <b id="pp-starter-price"></b></span></label>';
    html += '<label class="pp-field">Colours, preferences and anything to avoid<textarea id="pp-notes" rows="2"></textarea></label>';
  } else {
    if (f.shape) {
      html += '<div class="pp-group" id="pp-shape-group"><span class="pp-label">Shape</span>' +
        '<label class="pp-radio"><input type="radio" name="pp-shape" value="Circle (round and flat)" checked> <span>Circle, round and flat</span></label>' +
        '<label class="pp-radio"><input type="radio" name="pp-shape" value="Vertical"> <span>Vertical</span></label></div>';
    }
    if (f.greenery) {
      html += '<div class="pp-group"><span class="pp-label">Greenery</span>' +
        '<label class="pp-radio"><input type="radio" name="pp-green" value="with" checked> <span>With greenery <b id="pp-green-price"></b></span></label>' +
        '<label class="pp-radio"><input type="radio" name="pp-green" value="without"> <span>No greenery</span></label></div>';
    }
    if (f.handTie) {
      html += '<div class="pp-note pp-forced" id="pp-forced" hidden></div>';
      html += '<div class="pp-group" id="pp-forced-mat" hidden><span class="pp-label">Vase</span>' +
        '<label class="pp-radio"><input type="radio" name="pp-fmat" value="Glass" checked> <span>Glass (transparent)</span></label>' +
        '<label class="pp-radio"><input type="radio" name="pp-fmat" value="Ceramic"> <span>Ceramic (opaque)</span></label></div>';
    }
    if (f.budget) {
      html += '<label class="pp-check"><input type="checkbox" id="pp-big"> <span>Make it as big as possible for my budget</span></label>';
      html += '<label class="pp-field">Colour theme and anything else we should know<textarea id="pp-notes" rows="3" placeholder="e.g. pinks and whites, no red, for a birthday"></textarea></label>';
    } else {
      html += '<label class="pp-field">Colours and notes<textarea id="pp-notes" rows="2" placeholder="e.g. soft pink and white, no red"></textarea></label>';
    }

    html += '<span class="pp-label pp-sub">Add-ons</span>';
    if (f.bqGreen) {
      html += '<label class="pp-check"><input type="checkbox" id="pp-bqgreen"> <span>Extra greenery <b id="pp-bqgreen-price"></b></span></label>';
    }
    if (f.luxe) {
      html += '<label class="pp-check"><input type="checkbox" id="pp-luxe"> <span>Luxe wrapping <b id="pp-luxe-price"></b></span></label>';
    }
    if (f.vessel) {
      html += '<div id="pp-vessel-block"><label class="pp-field pp-inline">Vase, hat box or basket ' +
        '<select id="pp-vessel"><option value="">None</option><option value="Glass">Glass vase (transparent)</option>' +
        '<option value="Ceramic">Ceramic vase (opaque)</option><option value="Hat box">Hat box</option><option value="Basket">Basket</option></select></label>' +
        '<p class="pp-note" id="pp-vessel-note" hidden></p></div>';
    }
    if (f.orchid) {
      html += '<label class="pp-check"><input type="checkbox" id="pp-orchid"> <span>Premium orchid stems <b id="pp-orchid-price"></b></span></label>' +
        '<div class="pp-sub-fields" id="pp-orchid-fields" hidden>' +
        '<label class="pp-field pp-inline">Variety <select id="pp-orchid-type"></select></label>' +
        '<label class="pp-field pp-inline">Stems <input type="number" id="pp-orchid-qty" min="1" max="20" value="1"></label></div>';
    }
    if (f.breathAuto) {
      html += '<label class="pp-check"><input type="checkbox" id="pp-breath"> <span>Baby\'s breath <b id="pp-breath-price"></b></span></label>' +
        '<div class="pp-sub-fields" id="pp-breath-fields" hidden><label class="pp-field pp-inline">Style <select id="pp-breath-style"></select></label></div>';
    }
    if (f.breathBunch) {
      html += '<label class="pp-check"><input type="checkbox" id="pp-breath"> <span>Baby\'s breath, per bunch <b id="pp-breath-price"></b></span></label>' +
        '<div class="pp-sub-fields" id="pp-breath-fields" hidden>' +
        '<label class="pp-field pp-inline">Style <select id="pp-breath-style"></select></label>' +
        '<label class="pp-field pp-inline">Bunches <input type="number" id="pp-breath-qty" min="1" max="20" value="1"></label></div>';
    }
    if (f.letters) {
      html += '<label class="pp-check"><input type="checkbox" id="pp-letters"> <span>Baby\'s breath letters <b id="pp-letters-price"></b></span></label>' +
        '<div class="pp-sub-fields" id="pp-letters-fields" hidden>' +
        '<label class="pp-field">Word or name (letters and numbers count)<input type="text" id="pp-letters-text" maxlength="20"></label>' +
        '<p class="pp-note" id="pp-letters-note"></p></div>';
    }
    if (f.ribbon) {
      html += '<label class="pp-check"><input type="checkbox" id="pp-ribbon"> <span>Vinyl ribbon message <b id="pp-ribbon-price"></b></span></label>' +
        '<div class="pp-sub-fields" id="pp-ribbon-fields" hidden><label class="pp-field">Message on the ribbon<input type="text" id="pp-ribbon-text" maxlength="40"></label></div>';
    }
  }

  if (f.request) {
    html += '<span class="pp-label pp-sub">Want specific flowers?</span>' +
      '<label class="pp-field">Request specific flowers (optional)<textarea id="pp-req-flowers" rows="2" placeholder="e.g. oriental lilies, garden roses, sweet peas"></textarea></label>' +
      '<p class="pp-note">Leave this blank to order now. If you request specific flowers, we\'ll confirm the price before you pay.</p>' +
      '<div id="pp-req-fields" hidden>' +
      '<p class="pp-note pp-forced">Nothing is charged now. We\'ll confirm your flowers and the final price first, then send you a secure payment link once you approve it.</p>' +
      '<label class="pp-field">Your name<input type="text" id="pp-req-name" maxlength="80" autocomplete="name"></label>' +
      '<label class="pp-field">Email<input type="text" id="pp-req-email" maxlength="120" autocomplete="email"></label>' +
      '<label class="pp-field">Phone<input type="text" id="pp-req-phone" maxlength="30" autocomplete="tel"></label>' +
      '<label class="pp-field">Date you need it<input type="text" id="pp-req-date" maxlength="40" placeholder="e.g. Saturday 12 October"></label>' +
      '<label class="pp-field">Delivery address, or pickup<input type="text" id="pp-req-where" maxlength="160"></label></div>';
  }
  html += '<span class="pp-label pp-sub">Gift card (optional)</span>' +
    '<label class="pp-field">Message<textarea id="pp-gift" rows="2"></textarea></label>' +
    '<label class="pp-field">From<input type="text" id="pp-from" maxlength="60"></label>' +
    '<p class="pp-note">Please order at least one day ahead. Need it sooner? Call or text 0418 859 997. Flowers are seasonal, so we may substitute like-for-like (see Terms of service).</p>' +
    '<div class="pp-total" aria-live="polite"><span>Total so far</span><b id="pp-total"></b></div>' +
    '<p class="pp-note">Delivery is worked out at checkout.</p>' +
    '<p class="pp-error" id="pp-error" role="alert" hidden></p></fieldset>';
  root.insertAdjacentHTML('beforeend', html);

  function $(id) { return document.getElementById(id); }
  function on(id) { var e = $(id); return !!(e && e.checked); }
  function val(id) { var e = $(id); return e ? e.value : ''; }
  function show(id, yes) { var e = $(id); if (e) e.hidden = !yes; }

  /* fill the selects from the add-on data */
  function fillSelect(id, values) {
    var s = $(id);
    if (!s) return;
    s.innerHTML = values.map(function (v) { return '<option>' + esc(v) + '</option>'; }).join('');
  }

  fillSelect('pp-orchid-type', uniq(A.orchid, 'o1'));
  fillSelect('pp-breath-style', uniq(A.breath, 'o1'));

  /* ---------- price calculation ---------- */
  function lines() {
    var out = []; // {variant, qty, label, props}
    var n = stems();
    var mv = mainVariant();
    var mainCents = mv ? mv.p : 0;
    var forced = !!(f.handTie && n && n > HAND_TIE_MAX);

    if (isSub) {
      if (on('pp-starter') && A.starterVase[0]) {
        out.push({ v: A.starterVase[0], qty: 1, label: 'Starter vase (one-off)' });
      }
      return { lines: out, mainCents: mainCents, forced: false, n: n };
    }

    if (f.greenery && radio('pp-green') === 'with') {
      var g = pick(A.greenery, String(n));
      if (g) out.push({ v: g, qty: 1, label: 'Greenery' });
    }
    if (forced) {
      var fv = vaseFor(radio('pp-fmat') || 'Glass', mainCents);
      if (fv) out.push({ v: fv, qty: 1, label: radio('pp-fmat') + ' vase arrangement' });
    }
    if (f.bqGreen && on('pp-bqgreen')) {
      var bg = pick(A.bqGreen, sizeName());
      if (bg) out.push({ v: bg, qty: 1, label: 'Extra greenery' });
    }
    if (f.luxe && on('pp-luxe') && A.luxe[0]) {
      out.push({ v: A.luxe[0], qty: n ? Math.ceil(n / PER_25) : 1, label: 'Luxe wrapping' });
    }
    if (f.vessel && !forced) {
      var vs = val('pp-vessel');
      if (isVaseChoice(vs)) {
        var vv = vaseFor(vs, mainCents);
        if (vv) out.push({ v: vv, qty: 1, label: vaseLabel(vs) });
      } else if (vs === 'Basket') {
        var big = (n && n > BIG_ORDER_STEMS) || mainCents >= BIG_ORDER_CENTS;
        var bv = big ? pickStartsWith(A.basket, 'Larger') : pickStartsWith(A.basket, 'Smaller');
        bv = bv || A.basket[0];
        if (bv) out.push({ v: bv, qty: 1, label: 'Basket' });
      }
    }
    if (f.orchid && on('pp-orchid')) {
      var ov = pick(A.orchid, val('pp-orchid-type'));
      var oq = Math.max(1, Math.min(20, parseInt(val('pp-orchid-qty'), 10) || 1));
      if (ov) out.push({ v: ov, qty: oq, label: val('pp-orchid-type') + ' orchid' });
    }
    if (f.breathAuto && on('pp-breath')) {
      var bav = pick(A.breath, val('pp-breath-style'));
      if (bav) out.push({ v: bav, qty: n ? Math.max(1, Math.ceil(n / PER_25)) : 1, label: "Baby's breath, " + String(val('pp-breath-style')).toLowerCase() });
    }
    if (f.breathBunch && on('pp-breath')) {
      var bbv = pick(A.breath, val('pp-breath-style'));
      var bq = Math.max(1, Math.min(20, parseInt(val('pp-breath-qty'), 10) || 1));
      if (bbv) out.push({ v: bbv, qty: bq, label: "Baby's breath, " + String(val('pp-breath-style')).toLowerCase() });
    }
    if (f.letters && on('pp-letters')) {
      var lc = letterCount(val('pp-letters-text'));
      if (lc > 0) {
        var lv = (n && n >= LETTER_BIG_FROM) ? pickStartsWith(A.letters, '100') : pickStartsWith(A.letters, 'Under');
        lv = lv || A.letters[0];
        if (lv) out.push({ v: lv, qty: lc, label: "Baby's breath letters", props: { 'Letters': val('pp-letters-text').trim() } });
      }
    }
    if (f.ribbon && on('pp-ribbon') && val('pp-ribbon-text').trim() && A.ribbon[0]) {
      out.push({ v: A.ribbon[0], qty: 1, label: 'Vinyl ribbon message', props: { 'Message': val('pp-ribbon-text').trim() } });
    }
    return { lines: out, mainCents: mainCents, forced: forced, n: n };
  }
  function radio(name) {
    var e = document.querySelector('input[name="' + name + '"]:checked');
    return e ? e.value : '';
  }

  /* ---------- keep labels and totals up to date ---------- */
  function refresh() {
    var n = stems();
    var mv = mainVariant();
    var mainCents = mv ? mv.p : 0;
    var forced = !!(f.handTie && n && n > HAND_TIE_MAX);
    var per;

    if (isSub) {
      if ($('pp-starter-price') && A.starterVase[0]) $('pp-starter-price').textContent = '(' + money(A.starterVase[0].p) + ')';
    } else {
      if (f.greenery && $('pp-green-price')) {
        var g = pick(A.greenery, String(n));
        $('pp-green-price').textContent = g ? '(+' + money(g.p) + ')' : '';
      }
      if (f.handTie) {
        show('pp-shape-group', !forced);
        show('pp-forced', forced);
        show('pp-forced-mat', forced);
        if (forced) {
          var fv = vaseFor(radio('pp-fmat') || 'Glass', mainCents);
          $('pp-forced').textContent = 'Over ' + HAND_TIE_MAX + ' reflexed roses is too many to hand-tie, so this order is arranged in a vase' +
            (fv ? ' (' + money(fv.p) + ' added automatically)' : '') + '. Choose glass or ceramic below.';
        }
      }
      if (f.bqGreen && $('pp-bqgreen-price')) {
        var bgv = pick(A.bqGreen, sizeName());
        $('pp-bqgreen-price').textContent = bgv ? '(+' + money(bgv.p) + ')' : '';
      }
      if (f.luxe && A.luxe[0] && $('pp-luxe-price')) {
        var q = n ? Math.ceil(n / PER_25) : 1;
        $('pp-luxe-price').textContent = '(+' + money(A.luxe[0].p * q) + (q > 1 ? ', ' + q + ' × ' + money(A.luxe[0].p) + ' per 25 stems' : '') + ')';
      }
      if (f.vessel) {
        show('pp-vessel-block', !forced);
        var vs = val('pp-vessel');
        var note = $('pp-vessel-note');
        if (note) {
          if (vs === 'Basket') {
            var big = (n && n > BIG_ORDER_STEMS) || mainCents >= BIG_ORDER_CENTS;
            var bv = big ? pickStartsWith(A.basket, 'Larger') : pickStartsWith(A.basket, 'Smaller');
            note.textContent = bv ? ('Basket ' + money(bv.p) + (big ? ' (larger orders start here, we\'ll confirm the final size)' : '')) : '';
            note.hidden = !bv;
          } else if (isVaseChoice(vs)) {
            var vv = vaseFor(vs, mainCents);
            note.textContent = vv ? (vaseLabel(vs) + ': ' + money(vv.p) + ', sized to suit your order') : '';
            note.hidden = !vv;
          } else {
            note.hidden = true;
          }
        }
      }
      if (f.orchid) {
        var ov = pick(A.orchid, val('pp-orchid-type')) || A.orchid[0];
        if (ov && $('pp-orchid-price')) $('pp-orchid-price').textContent = '(' + money(ov.p) + ' a stem)';
        show('pp-orchid-fields', on('pp-orchid'));
      }
      if (f.breathAuto || f.breathBunch) {
        var bb = pick(A.breath, val('pp-breath-style')) || A.breath[0];
        if (bb && $('pp-breath-price')) {
          if (f.breathAuto) {
            var bq = n ? Math.max(1, Math.ceil(n / PER_25)) : 1;
            $('pp-breath-price').textContent = '(+' + money(bb.p * bq) + ', ' + money(bb.p) + ' per 25 roses)';
          } else {
            $('pp-breath-price').textContent = '(' + money(bb.p) + ' a bunch)';
          }
        }
        show('pp-breath-fields', on('pp-breath'));
      }
      if (f.letters) {
        var lv = (n && n >= LETTER_BIG_FROM) ? pickStartsWith(A.letters, '100') : pickStartsWith(A.letters, 'Under');
        lv = lv || A.letters[0];
        if (lv && $('pp-letters-price')) $('pp-letters-price').textContent = '(' + money(lv.p) + ' a letter)';
        show('pp-letters-fields', on('pp-letters'));
        var lc = letterCount(val('pp-letters-text'));
        if ($('pp-letters-note')) $('pp-letters-note').textContent = lc ? (lc + ' letter' + (lc > 1 ? 's' : '') + ' = ' + money(lv.p * lc)) : '';
      }
      if (f.ribbon) {
        var rb = A.ribbon[0];
        if (rb && $('pp-ribbon-price')) $('pp-ribbon-price').textContent = '(' + money(rb.p) + ')';
        show('pp-ribbon-fields', on('pp-ribbon'));
      }
    }

    var calc = lines();
    var total = calc.mainCents;
    calc.lines.forEach(function (l) { total += l.v.p * l.qty; });
    $('pp-total').textContent = money(total);
    if (f.request) applyRequestMode();
  }

  /* ---------- request specific flowers (no payment until we confirm) ---------- */
  var origBtnText = null;
  function requestMode() { return !!(f.request && val('pp-req-flowers').trim()); }
  function applyRequestMode() {
    var yes = requestMode();
    show('pp-req-fields', yes);
    var fm = form();
    if (!fm) return;
    var btn = fm.querySelector('[type="submit"]');
    var span = btn && btn.querySelector('span');
    if (span) {
      if (origBtnText === null) origBtnText = span.textContent;
      if (yes) span.textContent = 'Request a quote';
      else if (span.textContent === 'Request a quote') span.textContent = origBtnText;
    }
    document.querySelectorAll('.shopify-payment-button, .product-form__buttons .shopify-payment-button').forEach(function (b) {
      b.style.display = yes ? 'none' : '';
    });
  }
  function sendRequest() {
    var calc = lines();
    var mv = mainVariant();
    var L = [];
    L.push('Quote request: ' + data.title + (mv ? ' (' + mv.o1 + (mv.o2 ? ', ' + mv.o2 : '') + ', ' + money(mv.p) + ')' : ''));
    L.push('');
    L.push('Flowers requested: ' + val('pp-req-flowers').trim());
    if (val('pp-notes').trim()) L.push('Colours and notes: ' + val('pp-notes').trim());
    if (calc.lines.length) {
      L.push('');
      L.push('Add-ons:');
      calc.lines.forEach(function (l) { L.push('- ' + l.label + (l.qty > 1 ? ' x ' + l.qty : '') + ' (' + money(l.v.p * l.qty) + ')'); });
    }
    var tot = calc.mainCents; calc.lines.forEach(function (l) { tot += l.v.p * l.qty; });
    L.push('');
    L.push('Starting price before flower changes: ' + money(tot));
    L.push('');
    L.push('Name: ' + val('pp-req-name').trim());
    L.push('Email: ' + val('pp-req-email').trim());
    L.push('Phone: ' + val('pp-req-phone').trim());
    L.push('Date needed: ' + val('pp-req-date').trim());
    L.push('Delivery address or pickup: ' + val('pp-req-where').trim());
    if (val('pp-gift').trim()) { L.push(''); L.push('Gift message: ' + val('pp-gift').trim() + (val('pp-from').trim() ? ' (from ' + val('pp-from').trim() + ')' : '')); }
    var qf = document.getElementById('pp-quote-form');
    if (qf) {
      var set = function (k, v) { var i = qf.querySelector('[data-pp-f="' + k + '"]'); if (i) i.value = v; };
      set('name', val('pp-req-name').trim());
      set('email', val('pp-req-email').trim());
      set('phone', val('pp-req-phone').trim());
      set('body', L.join('\n'));
      window.__ppQuoteBody = L.join('\n');
      HTMLFormElement.prototype.submit.call(qf);
      return;
    }
    var url = 'mailto:petalpostt@gmail.com?subject=' + encodeURIComponent('Quote request: ' + data.title) + '&body=' + encodeURIComponent(L.join('\n'));
    window.__ppLastMailto = url;
    window.location.href = url;
    showError('');
    var ok = $('pp-error');
    if (ok) {
      ok.hidden = false;
      ok.style.color = 'inherit';
      ok.textContent = 'Your email is ready to send. If it did not open, email petalpostt@gmail.com or message us on Instagram @petalpostt. Nothing has been charged.';
    }
  }

  /* ---------- add to cart ---------- */
  function buildItems() {
    var calc = lines();
    var mv = mainVariant();
    var bundle = 'pp' + Date.now().toString(36);
    var props = {};
    var notes = val('pp-notes').trim();
    if (notes) props['Colours and notes'] = notes;
    if (f.budget && on('pp-big')) props['As big as possible'] = 'Yes';
    if (f.shape && !calc.forced) props['Shape'] = radio('pp-shape');
    if (f.greenery) props['Greenery'] = radio('pp-green') === 'with' ? 'With greenery' : 'No greenery';
    if (calc.forced) props['Arrangement'] = 'Vase arrangement (over ' + HAND_TIE_MAX + ' stems)';
    var gift = val('pp-gift').trim();
    var from = val('pp-from').trim();
    if (gift) props['Gift message'] = gift;
    if (from) props['Gift from'] = from;
    props['_pp_bundle'] = bundle;
    var items = [{ id: mv.id, quantity: 1, properties: props }];
    var forText = calc.n ? (calc.n + ' ' + (f.unit || 'stems')) : data.title;
    calc.lines.forEach(function (l) {
      var p = { 'For': forText, '_pp_bundle': bundle };
      if (l.props) for (var k in l.props) p[k] = l.props[k];
      items.push({ id: l.v.id, quantity: l.qty, properties: p });
    });
    return items;
  }

  function showError(msg) {
    var e = $('pp-error');
    if (!e) return;
    e.textContent = msg || '';
    e.hidden = !msg;
  }

  function validate() {
    if (requestMode()) {
      if (!val('pp-req-name').trim()) return 'Please add your name so we know who to reply to.';
      if (!/^\S+@\S+\.\S+$/.test(val('pp-req-email').trim())) return 'Please add a valid email address.';
      if (!val('pp-req-phone').trim()) return 'Please add a phone number.';
      if (!val('pp-req-date').trim()) return 'Please tell us the date you need it.';
    }
    if (f.letters && on('pp-letters') && letterCount(val('pp-letters-text')) === 0) return 'Please type the word or name for your letters, or untick baby\'s breath letters.';
    if (f.ribbon && on('pp-ribbon') && !val('pp-ribbon-text').trim()) return 'Please type the message for your ribbon, or untick the ribbon message.';
    return '';
  }

  var busy = false;
  document.addEventListener('submit', function (e) {
    var fm = form();
    if (!fm || e.target !== fm) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return;

    var problem = validate();
    showError(problem);
    if (problem) return;

    if (requestMode()) { sendRequest(); return; }

    busy = true;
    var btn = fm.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    var spinner = fm.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    var items = buildItems();
    var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { items: items };
    if (cartEl && cartEl.getSectionsToRender) {
      body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (resp.status) {
          showError(resp.description || resp.message || 'Sorry, that could not be added. Please try again.');
          return;
        }
        if (!cartEl) { window.location = window.routes.cart_url; return; }
        var first = (resp.items && resp.items[0]) || {};
        var state = { key: first.key, id: first.id, sections: resp.sections };
        try {
          if (window.publish && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'petal-options', productVariantId: first.id, cartData: state });
          }
        } catch (err) { /* not critical */ }
        cartEl.renderContents(state);
      })
      .catch(function () {
        showError('Something went wrong adding to your cart. Please try again.');
      })
      .then(function () {
        busy = false;
        if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
        if (spinner) spinner.classList.add('hidden');
      });
  }, true);

  /* ---------- quote sent confirmation ---------- */
  if (root.querySelector('[data-pp-posted]') || /[?&]contact_posted=true/.test(window.location.search)) {
    var box = root.querySelector('.pp-box');
    if (box) {
      box.insertAdjacentHTML('afterbegin', '<p class="pp-note pp-forced pp-sent">Thanks, your request has been sent. We\'ll reply with your flowers and final price, and nothing is charged until you approve it.</p>');
      setTimeout(function () { box.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 300);
    }
  }

  /* ---------- wire up ---------- */
  root.addEventListener('input', refresh);
  root.addEventListener('change', refresh);
  // variant changes happen in the theme's own picker, so watch the hidden id field
  var lastId = null;
  setInterval(function () {
    var v = mainVariant();
    var id = v ? v.id : null;
    if (id !== lastId) { lastId = id; refresh(); }
  }, 300);
  refresh();
})();
